import CryptoJS from 'crypto-js';
const { AES, mode, enc, pad } = CryptoJS;

export default {
  data() {
    return {
      ENCRYPTION_KEY: enc.Utf8.parse(process.env.APP_VUE_EMAIL_ENCRYPTION_KEY),
    };
  },
  methods: {
    encryptPassword(password: string): string {
      return AES.encrypt(password, this.ENCRYPTION_KEY, { mode: mode.ECB }).toString();
    },

    decryptPassword(encrypted: string): string {
      const bytes = AES.decrypt(encrypted, this.ENCRYPTION_KEY, { mode: mode.ECB });
      return bytes.toString(enc.Utf8);
    },

    generalEncryption(fieldValue: any) {
      const EMAIL_ENCRYPTION_KEY = process.env.APP_VUE_EMAIL_ENCRYPTION_KEY;
      const key = enc.Utf8.parse(String(EMAIL_ENCRYPTION_KEY));
      return AES.encrypt(String(fieldValue), key, {
        mode: mode.ECB,
        padding: pad.Pkcs7,
      });
    },

    generalDecryption(fieldValue: any) {
      const EMAIL_ENCRYPTION_KEY = process.env.APP_VUE_EMAIL_ENCRYPTION_KEY;
      const key = enc.Utf8.parse(String(EMAIL_ENCRYPTION_KEY));
      return AES.decrypt(String(fieldValue), key, { mode: mode.ECB });
    },
  },
};
